import * as types from "./mutation-types";
import { teamsService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";

export const fetchTeamList = async ({ commit }, payload) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const params = { page: payload.page, items: payload.items };
    const response = await teamsService.list(payload.realEstateId, params);
    commit(types.SET_TEAMS_LIST, response.data.data);
    commit(types.SET_TOTAL_ITEMS, response.data.meta.count);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

// eslint-disable-next-line no-unused-vars
export const getTeamById = async ({ commit }, payload) => {
  let team = {};

  try {
    const response = await teamsService.getById(payload);
    team = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um error inesperado.");
  }

  return team;
};

export const createTeam = async ({ commit }, payload) => {
  try {
    const response = await teamsService.create(payload.realEstateId, payload);
    commit(types.TEAMS_LIST_ADD_ITEM, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

export const updateTeam = async ({ commit }, payload) => {
  try {
    const response = await teamsService.update(payload.realEstateId, payload);
    commit(types.TEAMS_LIST_UPDATE_ITEM, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

export const updateTeamSearch = async ({ commit }, payload) => {
  commit(types.SET_SEARCH, payload);
};
